/***
 *
 * NOTE: This is ONLY for <Helmet /> in `src/containers/App/AppContainer`
 *
 */
import { getAppLanguage } from 'redux/reducers/utils/i18n/helpers';
import { APP_URL, FACEBOOK_APP_ID } from 'config/constants';

const STATIC_CONFIG = {
    image: `${APP_URL}/Logo.png`,
    siteName: 'Prism Medical UK, moving, handling and bathing solutions',
    type: 'website',
    language: getAppLanguage(),
    twitterSite: '@PrismMedicalUK',
    fbAppId: FACEBOOK_APP_ID,
    children: null,
    twitterCard: 'twitter'
};

// HELMET - see https://github.com/SchwSimon/creatella-react-components#helmet-
export default {
    en: {
        ...STATIC_CONFIG,
        description: 'Prism Medical UK, moving, handling and bathing solutions',
        title: 'Prism Medical UK, moving, handling and bathing solutions'
    }
    // de: { ... }
    // fr: { ... }
    // ...
};
